var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconConnected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33945 15.7477L6.59163 13.9999L1.6333 18.9583L6.59163 23.9166L8.33945 22.1688L6.3809 20.1978H25.1854V17.7187H6.3809L8.33945 15.7477Z",
    fill: "#100F0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7188 12.2521L21.4666 13.9999L26.425 9.04159L21.4666 4.08325L19.7188 5.83106L21.6774 7.802H2.87288V10.2812H21.6774L19.7188 12.2521Z",
    fill: "#100F0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnected);
export default __webpack_public_path__ + "static/media/icon_connected.8d3771a351dd3660a5dfebe71d2c3bce.svg";
export { ForwardRef as ReactComponent };